import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output
} from '@angular/core';

@Component({
  selector: 'app-file-selector',
  templateUrl: './file-selector.component.html',
  styleUrls: ['./file-selector.component.scss'],
})
export class FileSelectorComponent {
  @Output() fileChange = new EventEmitter<File>();

  /** File types to accept */
  @Input() accept: string;
  /** Attached file */
  @Input() file: File;

  /** Use Compact Layout? */
  @Input() compact: boolean;

  onFileSelected(files: FileList) {
    if (files.length > 0) {
      this.fileChange.emit(files.item(0));
    }
  }

  onRemoveFileClick() {
    this.fileChange.emit(null);
  }
}
